import React from 'react';
import {noop} from 'lodash';

import ClientRole from '/component/partial/report/ClientRole';
import ClientsListHeader from '/component/partial/report/ClientsListHeader';
import LastOrderedDate from '/component/partial/report/LastOrderedDate';
import PeopleReportDataRenderer from '/component/partial/report/PeopleReportDataRenderer';
import ReportDataProvider from '/component/partial/report/ReportDataProvider';

import {generateOnRecordPress} from './AllGen0ClientsReports.util';
import reportPayload from './reportPayload';

import {useRecordsSorting} from '/context/RecordsSort/useRecordsSorting';
interface AllGen0ClientsContentProps {
  recordsShowPopover: () => void;
  recordsShowRecord: () => void;
  onOrderPress: () => void;
  showRecordPopover: () => void;
  loadingData: {
    total?: number;
  };
}

export const AllGen0ClientsContent = ({
  loadingData = {},
  showRecordPopover = noop,
  recordsShowPopover = noop,
  recordsShowRecord = noop,
  onOrderPress = noop,
}: AllGen0ClientsContentProps) => {
  const {isReadyToLoad, sortParam} = useRecordsSorting({
    recordsName: reportPayload.reportName,
  });

  if (!isReadyToLoad) {
    return null;
  }

  return (
    <ReportDataProvider
      {...reportPayload}
      dataRenderer={PeopleReportDataRenderer}
      dataRendererProps={{
        listHeaderComponent: ClientsListHeader,
        personRoleComponent: ClientRole,
        personInfoComponent: LastOrderedDate,
        onRecordPress: generateOnRecordPress({
          showRecordPopover,
          recordsShowPopover,
          recordsShowRecord,
          onOrderPress,
        }),
      }}
      loadingData={loadingData}
      reportParams={[{...sortParam.params}]}
    />
  );
};
